module.exports = __webpack_public_path__ + "img/footer_taobao.e12c41f3.png";